import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ro from './locales/ro.json';
import en from './locales/en.json';

export const SUPPORTED_LANGUAGES = ['ro', 'en'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

const LANG_STORAGE_KEY = 'kreart.lang';

function readStoredLanguage(): SupportedLanguage {
  if (typeof window === 'undefined') return 'ro';
  try {
    const stored = window.localStorage.getItem(LANG_STORAGE_KEY);
    if (stored && (SUPPORTED_LANGUAGES as readonly string[]).includes(stored)) {
      return stored as SupportedLanguage;
    }
  } catch {
    /* localStorage may be unavailable (private mode, etc.) — fall through */
  }
  return 'ro';
}

void i18n.use(initReactI18next).init({
  resources: {
    ro: { translation: ro },
    en: { translation: en },
  },
  lng: readStoredLanguage(),
  fallbackLng: 'en',
  supportedLngs: [...SUPPORTED_LANGUAGES],
  interpolation: { escapeValue: false },
});

// Keep <html lang> in sync for screen readers / search engines / spell-check.
const syncDocumentLang = (lng: string): void => {
  if (typeof document !== 'undefined' && document.documentElement) {
    document.documentElement.lang = lng;
  }
};
const persistLang = (lng: string): void => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(LANG_STORAGE_KEY, lng);
  } catch {
    /* ignore quota / unavailable storage */
  }
};
syncDocumentLang(i18n.language);
i18n.on('languageChanged', (lng) => {
  syncDocumentLang(lng);
  persistLang(lng);
});

export default i18n;
